var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBgPatternLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillOpacity: 0.22
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#ffffff",
    cx: 400,
    cy: 400,
    r: 600
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#eff3ff",
    cx: 400,
    cy: 400,
    r: 500
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#cddbff",
    cx: 400,
    cy: 400,
    r: 300
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#bbcfff",
    cx: 400,
    cy: 400,
    r: 200
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#a8c4ff",
    cx: 400,
    cy: 400,
    r: 100
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgPatternLight);
export default __webpack_public_path__ + "static/media/bg-pattern-light.76f84bb307e1cb63896a6ab492703eba.svg";
export { ForwardRef as ReactComponent };